import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-lira', 'CurrencyLira', [["path",{"d":"M10 5v15a7 7 0 0 0 7 -7"}],["path",{"d":"M6 15l8 -4"}],["path",{"d":"M14 7l-8 4"}]]);